import styled from 'styled-components';
import {
  Dropdown as SemanticDropdown,
  Modal as SemanticModal,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent, Segment as SegmentLayoutComponent, Text as TextLayoutComponent, Loader as LoaderLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled(SegmentLayoutComponent)`
    position: relative;
    &.ui.segment {
    margin-bottom: 20px;
    padding: 20px;
    width: 100%;
  }
`;

export const Title = styled(TextLayoutComponent.Title)``;

export const Content = styled.div`
  padding: 20px 0;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Dropdown = styled(SemanticDropdown)``;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 100px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const LabelDropdown = styled(TextLayoutComponent)`
  margin-right: 10px;
`;

export const Modal = styled(SemanticModal)``;

export const ModalHeader = styled(TextLayoutComponent.Header)`
  margin-left: 20px;
`;

export const ModalParagraph = styled(TextLayoutComponent.Span)`
  display: flex;
  margin: 20px;
  font-weight: 500;
`;

export const ModalLink = styled.div`
  display: flex;
  margin-left: 20px;
  margin-right: 20px;
`;

export const ContainerWarningTimezone = styled.div`
  background-color: #B9CFFF;
  border-radius: 4px;
  margin: 20px;
`;

export const WarningTimezoneMessage = styled(TextLayoutComponent.Span)`
  display: flex;
  text-align: center;
  font-weight: 500;
  padding: 10px;
`;

export const ContainerLoading = styled.div`
  position: absolute;
  margin-top: 28px;
  display: flex;
  width: 100%;
  justify-content: center;
`;

export const Loader = styled(LoaderLayoutComponent)``;
